import React from 'react';

import {Section} from 'constants/NavConstants';
import navigateToURL from 'lib/navigateToURL';
import {navigateToProteinStructureTab} from 'molbio/aa-sequences/alphafold/AlphaFoldTabUtils';
import {expandSection} from 'nav/sidepanel/SidepanelActions';
import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';
import APIUtil from 'util/APIUtil';
import type {BasicEvent} from 'util/Types';

/**
 * A registry entity used as a prediction input. Clicking opens the entity (an AA sequence on its
 * structure tab) and doesn't reach clickable ancestors such as table rows.
 */
export default function EntityInputChip({entityId}: {entityId: string}): JSX.Element | null {
  return (
    <BenchChip
      id={entityId}
      size={ChipSize.SMALL}
      onClick={(event: BasicEvent, item: {editUrl?: string}) => {
        event.stopPropagation();
        if (APIUtil.isProtein(entityId)) {
          navigateToProteinStructureTab(entityId).catch(() => {});
          return;
        }
        expandSection(Section.PROJECTS);
        if (item.editUrl != null) {
          navigateToURL(item.editUrl);
        }
      }}
    />
  );
}
